import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchWorkEntries } from "../../../../../store/slices/workentriesSlice";
import SalesIntallation from "./SalesIntallation";
import SalesEfforts from "./SalesEfforts";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";

const SalesCalculations = ({ selectedProject, setfinanaceData, setprojectCostMap, sethtml }) => {
    const dispatch = useDispatch()
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    const [filteredQuotation, setFilteredQuotation] = useState(null);
    const [projectServiceCostMap, setProjectServiceCostMap] = useState({});
    const [showInstallationData] = useState(true)
    const [installation, setInstallation] = useState([]);
    const { tasks } = useSelector((state) => state.descriptionTasks);
    const [installationPLTableHtml, setInstallationPLTableHtml] = useState('');
    const [SalesFinanceEffortstableHtml, setSalesFinanceEffortstableHtml] = useState('');
    const [serviceTotals, setServiceTotals] = useState({});
    const [matchedProjects, setMatchedProjects] = useState([]); // always an array
    const [, setGroupedProjects] = useState([]);

    // const otherExpenses = useSelector((state) => state.otherExpenses);
    const { quotations } = useSelector((state) => state.hourlyRateQuotation);
    const { employees } = useSelector((state) => state.employees);
    const [matchedEntries, setMatchedEntries] = useState([]);
    const { projects } = useSelector((state) => state.projects);

    const { entries } = useSelector((state) => state.workentries);

    useEffect(() => {
        dispatch(fetchWorkEntries());
        dispatch(fetchQuotations());
        dispatch(fetchDescriptionTasks());
    }, [dispatch]);

    useEffect(() => {
        if (selectedProject && projects?.length) {
            const matches = projects.filter(
                (proj) =>
                    proj.ProjectName?.toLowerCase() ===
                    selectedProject?.toLowerCase()
            );
            setMatchedProjects(matches); // always an array
        } else {
            setMatchedProjects([]); // reset if no match
        }
    }, [selectedProject, projects]);// ✅ will store matched entries
    useEffect(() => {
        if (matchedProjects.length && entries.length) {
            const matchedIds = matchedProjects.map((proj) => proj._id);
            const filteredEntries = entries.filter((entry) =>
                matchedIds.includes(entry.projectid)
            );
            setMatchedEntries(filteredEntries);
        } else {
            setMatchedEntries([]);
        }
    }, [matchedProjects, entries]);
    useEffect(() => {
        if (!filteredQuotation) return;

        const newTotals = {};

        Object.entries(filteredQuotation).forEach(([projectName, typeServices]) => {
            Object.entries(typeServices).forEach(([typeService, items]) => {
                let totalCostForService = 0;

                items.forEach((item) => {
                    const groupedByPerson = {};
                    const personRoleMap = {};

                    item?.WorkEntries?.forEach((entry) => {
                        const personName = entry?.createdBy?.name;
                        const personRoles = entry?.createdBy?.role || [];

                        if (!groupedByPerson[personName]) groupedByPerson[personName] = 0;
                        groupedByPerson[personName] += entry.hoursassigned || 0;
                        if (!personRoleMap[personName]) personRoleMap[personName] = personRoles;
                    });

                    Object.entries(groupedByPerson).forEach(([name, totalHours]) => {
                        const roles = personRoleMap[name] || [];
                        const matchedQuotation = item?.quotationDetails?.find((q) =>
                            roles.some((role) =>
                                q.designation?.toLowerCase().includes(role?.toLowerCase())
                            )
                        );
                        const hourlyRate = matchedQuotation?.hourlysalaray || 0;
                        totalCostForService += hourlyRate > 0 ? totalHours * hourlyRate : 0;
                    });
                });

                if (!newTotals[typeService]) newTotals[typeService] = 0;
                newTotals[typeService] += totalCostForService;
            });
        });

        setServiceTotals(newTotals);
    }, [filteredQuotation]);


    useEffect(() => {
        const filteredTasks = tasks.filter(task => task.projectname === selectedProject);
        // Step 2: Group by createdBy
        const groupedByCreator = filteredTasks.reduce((acc, task) => {
            const creator = task.createdBy;
            if (!acc[creator]) {
                acc[creator] = [];
            }
            acc[creator].push(task);
            return acc;
        }, {});
        // Step 3: Store grouped tasks in state
        setInstallation(groupedByCreator);

    }, [tasks, selectedProject]);

    useEffect(() => {
        if (filteredQuotation) {
            setfinanaceData(filteredQuotation)
        }
    }, [filteredQuotation, setfinanaceData]);

    useEffect(() => {
        if (projectServiceCostMap) {
            setprojectCostMap(projectServiceCostMap)
        }
    }, [projectServiceCostMap, setprojectCostMap]);
    //  useEffect(() => {
    //     dispatch(setCurrentPageTitle("Sales Finance"));
    //   }, [dispatch]);


    // const { tasks } = useSelector(state => state.descriptionTasks);

    useEffect(() => {
        dispatch(fetchQuotations())
    }, [dispatch]);


    const [groupedProj, setGroupedProj] = useState({});

    // useEffect(() => {
    //     if (!projects || projects.length === 0 || !employees) return;

    //     const grouped = {};

    //     projects.forEach((proj) => {
    //         const projectName = proj.ProjectName;
    //         const typeService = proj.TypeService;

    //         // Deep clone WorkEntries to avoid mutating original data
    //         const clonedWorkEntries = proj.WorkEntries?.map((work) => {
    //             const newWork = { ...work, createdBy: { ...work.createdBy } };

    //             const empName = work?.createdBy?.name
    //                 ?.replace(/\s+/g, "")
    //                 .toLowerCase();

    //             const matchedEmployee = employees.find((emp) => {
    //                 const fullName = `${emp.EmpFirstName}${emp.EmpLastName}`
    //                     .replace(/\s+/g, "")
    //                     .toLowerCase();
    //                 return empName === fullName;
    //             });

    //             if (matchedEmployee) {
    //                 newWork.createdBy.role = matchedEmployee.customRoles || [];
    //             }

    //             return newWork;
    //         });

    //         // Only selected fields
    //         const filteredProject = {
    //             TypeService: proj.TypeService,
    //             ResourceType: proj.ResourceType,
    //             ProjectName: proj.ProjectName,
    //             QuotedValue: proj.QuotedValue,
    //             WorkEntries: clonedWorkEntries,
    //             AssignedGroup: proj.AssignedGroup,
    //             AssignedManagerEmail: proj.AssignedManagerEmail,
    //             Assignedperson: proj.Assignedperson,
    //         };

    //         if (!grouped[projectName]) {
    //             grouped[projectName] = {};
    //         }

    //         if (!grouped[projectName][typeService]) {
    //             grouped[projectName][typeService] = [];
    //         }

    //         grouped[projectName][typeService].push(filteredProject);
    //     });

    //     setGroupedProj(grouped);
    // }, [projects, employees]);
    const [finalMappedEntries, setFinalMappedEntries] = useState([]);

    useEffect(() => {
        if (matchedEntries.length && employees.length) {
            const mapped = matchedEntries.map((entry) => {
                const matchedEmp = employees.find((emp) => emp._id === entry.createdBy);

                return {
                    createdBy: {
                        email: matchedEmp.EmpEmail,
                        name: `${matchedEmp.EmpFirstName} ${matchedEmp.EmpLastName}`,
                        role: matchedEmp.customRoles || [],
                    },
                    task: entry.task,
                    hoursassigned: entry.hoursassigned,
                    taskStatus: entry.taskStatus,
                    notes: entry.notes,
                    _id: entry._id,
                };
            });

            setFinalMappedEntries(mapped);
        } else {
            setFinalMappedEntries([]);
        }
    }, [matchedEntries, employees]);

    useEffect(() => {
        if (!projects || projects.length === 0 || !employees) return;

        const grouped = {};

        projects.forEach((proj) => {
            const projectName = proj.ProjectName;
            const typeService = proj.TypeService;

            // Deep clone WorkEntries to avoid mutating original data
            // const clonedWorkEntries = proj.WorkEntries?.map((work) => {
            //   const newWork = { ...work, createdBy: { ...work.createdBy } };

            //   const empName = work?.createdBy?.name
            //     ?.replace(/\s+/g, "")
            //     .toLowerCase();

            //   const matchedEmployee = employees.find((emp) => {
            //     const fullName = `${emp.EmpFirstName}${emp.EmpLastName}`
            //       .replace(/\s+/g, "")
            //       .toLowerCase();
            //     return empName === fullName;
            //   });

            //   if (matchedEmployee) {
            //     newWork.createdBy.role = matchedEmployee.customRoles || [];
            //   }

            //   return newWork;
            // });

            // Only selected fields
            const filteredProject = {
                TypeService: proj.TypeService,
                ResourceType: proj.ResourceType,
                ProjectName: proj.ProjectName,
                QuotedValue: proj.QuotedValue,
                // WorkEntries: clonedWorkEntries,
                WorkEntries: finalMappedEntries,
                AssignedGroup: proj.AssignedGroup,
                AssignedManagerEmail: proj.AssignedManagerEmail,
                Assignedperson: proj.Assignedperson,
            };

            if (!grouped[projectName]) {
                grouped[projectName] = {};
            }

            if (!grouped[projectName][typeService]) {
                grouped[projectName][typeService] = [];
            }

            grouped[projectName][typeService].push(filteredProject);
        });

        setGroupedProj(grouped);
    }, [projects, employees, finalMappedEntries]);

    const [matchedQuotations, setMatchedQuotations] = useState({});

    useEffect(() => {
        if (!quotations || !groupedProj) return;

        const updatedGroupedProj = {};

        // Loop through each project
        Object.entries(groupedProj).forEach(([projectName, serviceTypes]) => {
            updatedGroupedProj[projectName] = {};

            // Loop through each TypeService within that project
            Object.entries(serviceTypes).forEach(([typeService, serviceArray]) => {
                // Keep the original service array
                const updatedServiceArray = serviceArray.map((entry) => {
                    // Match quotations where designation includes TypeService
                    const matchedQuotations = quotations.filter((q) =>
                        q.designation?.toLowerCase().includes(typeService.toLowerCase())
                    );

                    return {
                        ...entry,
                        quotationDetails: matchedQuotations, // add new key with matched quotations
                    };
                });

                updatedGroupedProj[projectName][typeService] = updatedServiceArray;
            });
        });

        setMatchedQuotations(updatedGroupedProj);
    }, [quotations, groupedProj]);

    useEffect(() => {
        if (projects?.length > 0 && employees?.length > 0) {
            const groupedByProjectName = projects.reduce((acc, project) => {
                const { ProjectName } = project;
                if (!acc[ProjectName]) {
                    acc[ProjectName] = [];
                }
                acc[ProjectName].push(project);
                return acc;
            }, {});

            const summarizedData = Object.entries(groupedByProjectName).map(
                ([projectName, projectGroup]) => {
                    const allAssignedManagerEmails = projectGroup.flatMap(
                        (p) => p.AssignedManagerEmail || []
                    );

                    // CASE 1: PrimaryResources is "1"
                    const flaggedProject = projectGroup.find(
                        (p) =>
                            p.PrimaryResources === "1" || Number(p.PrimaryResources) === 1
                    );

                    // CASE 2: PrimaryResources is email or array of emails
                    const primaryResourceEmails = flaggedProject
                        ? flaggedProject.AssignedManagerEmail || []
                        : projectGroup.flatMap((p) => {
                            if (
                                typeof p.PrimaryResources === "string" &&
                                p.PrimaryResources.includes("@")
                            ) {
                                return [p.PrimaryResources];
                            } else if (Array.isArray(p.PrimaryResources)) {
                                return p.PrimaryResources.filter((email) =>
                                    email.includes("@")
                                );
                            }
                            return [];
                        });

                    const getNameFromEmail = (email) => {
                        const person = employees.find((emp) => emp.EmpEmail === email);
                        return person
                            ? `${person.EmpFirstName} ${person.EmpLastName}`
                            : email;
                    };

                    const AssignedManager = [...new Set(allAssignedManagerEmails)].map(
                        getNameFromEmail
                    );

                    const PrimaryResource = [...new Set(primaryResourceEmails)].map(
                        getNameFromEmail
                    );

                    // ✅ Build detailed ProjectManagerAction array
                    const ProjectManagerAction = projectGroup.map((p) => {
                        const managerEmail = (p.AssignedManagerEmail || [])[0]; // Assuming 1 manager per project entry
                        const managerName = getNameFromEmail(managerEmail);
                        return {
                            Manager: managerName,
                            ManagerAction: p.ProjectManagerAction || "",
                            ResourceType: p.ResourceType || "",
                            TypeService: p.TypeService,
                        };
                    });

                    return {
                        ProjectName: projectName,
                        DateDue: projectGroup[0].ProjectDueDate,
                        AssignedManager,
                        PrimaryResource,
                        ProjectManagerAction,
                    };
                }
            );
            setGroupedProjects(summarizedData);
        }
    }, [projects, employees]);

    useEffect(() => {
        if (!selectedProject || !matchedQuotations) return;

        const match = matchedQuotations[selectedProject];

        if (match) {
            setFilteredQuotation({ [selectedProject]: match });
        } else {
            setFilteredQuotation(null); // or {} if you prefer
        }
    }, [selectedProject, matchedQuotations]);


    const totalCostsArray = []; // will collect totalCost for each person
    useEffect(() => {
        if (!filteredQuotation) return;

        const tempMap = {};

        Object.entries(filteredQuotation).forEach(([projectName, typeServices]) => {
            let totalProjectCost = 0; // ✅ Total cost for this project

            Object.entries(typeServices).forEach(([typeService, items]) => {
                let totalCostForService = 0;

                items.forEach((item) => {
                    const groupedByPerson = {};
                    const personRoleMap = {};

                    item?.WorkEntries?.forEach((entry) => {
                        const personName = entry?.createdBy?.name;
                        const personRoles = entry?.createdBy?.role || [];

                        if (!groupedByPerson[personName]) groupedByPerson[personName] = 0;
                        groupedByPerson[personName] += entry.hoursassigned || 0;
                        if (!personRoleMap[personName])
                            personRoleMap[personName] = personRoles;
                    });

                    Object.entries(groupedByPerson).forEach(([name, totalHours]) => {
                        const roles = personRoleMap[name] || [];

                        const matchedQuotation = item?.quotationDetails?.find((q) =>
                            roles.some((role) =>
                                q.designation?.toLowerCase().includes(role?.toLowerCase())
                            )
                        );

                        const hourlyRate = matchedQuotation?.hourlysalaray || 0;
                        const totalCost = hourlyRate > 0 ? totalHours * hourlyRate : 0;

                        totalCostForService += totalCost; // accumulate total for service
                    });
                });

                // ✅ Store cost for this service
                if (!tempMap[projectName]) tempMap[projectName] = {};

                tempMap[projectName][typeService] =
                    totalCostForService > 0
                        ? `${currency}${USAComma(totalCostForService.toFixed(2))}`
                        : "";

                totalProjectCost += totalCostForService; // ✅ accumulate for project total
            });

            // ✅ Add total cost for the whole project
            tempMap[projectName]["total"] =
                totalProjectCost > 0
                    ? `${currency}${USAComma(totalProjectCost.toFixed(2))}`
                    : "";
        });

        setProjectServiceCostMap(tempMap);
    }, [filteredQuotation, currency,USAComma]);

    // const renderServiceTableHTML = (serviceName) => {
    //     const groupedByPerson = {};
    //     const personRoleMap = {};
    //     const totalCostsTyperService = [];

    //     Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
    //         Object.entries(typeServices || {}).forEach(([typeService, items]) => {
    //             items.forEach((item) => {
    //                 if (item.TypeService !== serviceName || !item.WorkEntries?.length) return;

    //                 item.WorkEntries.forEach((entry) => {
    //                     const personName = entry?.createdBy?.name;
    //                     const personRoles = entry?.createdBy?.role || [];

    //                     if (!groupedByPerson[personName]) groupedByPerson[personName] = 0;
    //                     groupedByPerson[personName] += entry.hoursassigned || 0;

    //                     if (!personRoleMap[personName]) {
    //                         personRoleMap[personName] = personRoles;
    //                     }
    //                 });
    //             });
    //         });
    //     });

    //     if (Object.keys(groupedByPerson).length === 0) return '';

    //     let html = `<div class="border border-white my-4">
    //     <table class="w-full">
    //         <thead>
    //             <tr class="bg-blue-50">
    //                 <th colspan="3" class="text-center font-semibold p-2">${serviceName}</th>
    //             </tr>
    //         </thead>
    //         <tbody>`;

    //     Object.entries(groupedByPerson).forEach(([name, totalHours]) => {
    //         const roles = personRoleMap[name] || [];
    //         let hourlyRate = 0;

    //         Object.entries(filteredQuotation || {}).forEach(([_, typeServices]) => {
    //             Object.values(typeServices).forEach((items) => {
    //                 items.forEach((item) => {
    //                     if (item?.TypeService !== serviceName) return;

    //                     const match = item?.quotationDetails?.find((q) =>
    //                         roles.some((role) =>
    //                             q.designation?.toLowerCase().includes(role?.toLowerCase())
    //                         )
    //                     );
    //                     if (match) hourlyRate = match.hourlysalaray || 0;
    //                 });
    //             });
    //         });

    //         const totalCost = totalHours * hourlyRate;
    //         totalCostsArray.push(totalCost);
    //         totalCostsTyperService.push(totalCost);

    //         html += `<tr class="bg-blue-50 border border-white">
    //                 <td class="p-1 text-center">${name}</td>
    //                 <td class="p-1 text-center">${USAComma(totalHours)} Hrs</td>
    //                 <td class="p-1 text-center">${hourlyRate > 0 ? `${currency}${USAComma(totalCost)}` : "(Hourly Rate Not Available)"}</td>
    //             </tr>`;
    //     });

    //     const total = totalCostsTyperService.reduce((sum, cost) => sum + cost, 0).toFixed(2);

    //     html += `<tr class="bg-blue-50 border border-white">
    //             <td colspan="2" class="p-1"></td>
    //             <td class="p-1 text-right font-semibold">Total:- ${currency}${USAComma(total)}</td>
    //         </tr>
    //         </tbody>
    //     </table>`;

    //     if (serviceName === "Installation") {
    //         Object.entries(installation).forEach(([createdBy, tasks]) => {
    //             const tripDuration = tasks[0]?.tripduration || " ";
    //             html += `<div class="w-full mt-4">
    //                     <div class="bg-gray-100 text-sm font-medium p-2">TripDuration: ${tripDuration}</div>
    //                     <table class="w-full">
    //                         <thead>
    //                             <tr>
    //                                 <th class="w-1/10 border border-black p-1">#</th>
    //                                 <th class="w-2/5 border border-black p-2">Description</th>
    //                                 <th class="w-1/4 border border-black p-2">Value</th>
    //                                 <th class="w-1/4 border border-black p-2">Notes</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>`;

    //             tasks.forEach((row, index) => {
    //                 html += `<tr>
    //                             <td class="border border-black p-1 text-center">${index + 1}</td>
    //                             <td class="border border-black p-2">${row.description}</td>
    //                             <td class="border border-black p-2">${row.value}</td>
    //                             <td class="border border-black p-2">${row.notes}</td>
    //                         </tr>`;
    //             });

    //             html += `</tbody></table></div>`;
    //         });

    //         html += SalesFinanceEffortstableHtml || '';
    //         html += installationPLTableHtml || '';
    //     }
    //     if (serviceName === "Software") {

    //     }

    //     html += `</div>`;
    //     return html;
    // };
    const renderServiceTableHTML = (serviceName) => {
        const groupedByPerson = {};
        const personRoleMap = {};
        const totalCostsTyperService = [];

        Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
            Object.entries(typeServices || {}).forEach(([typeService, items]) => {
                items.forEach((item) => {
                    if (item.TypeService !== serviceName || !item.WorkEntries?.length) return;

                    item.WorkEntries.forEach((entry) => {
                        const personName = entry?.createdBy?.name;
                        const personRoles = entry?.createdBy?.role || [];

                        if (!groupedByPerson[personName]) groupedByPerson[personName] = 0;
                        groupedByPerson[personName] += entry.hoursassigned || 0;

                        if (!personRoleMap[personName]) {
                            personRoleMap[personName] = personRoles;
                        }
                    });
                });
            });
        });

        if (Object.keys(groupedByPerson).length === 0) return '';

        let html = `<div style="border: 1px solid #000; margin: 16px 0;">
    <table style="width: 100%; border-collapse: collapse;">
        <thead>
            <tr style="background-color: #3b82f6; color: white;">
                <th colspan="3" style="text-align: center; font-weight: bold; padding: 8px; border: 1px solid #000;">${serviceName}</th>
            </tr>
            <tr style="background-color: #bfdbfe;">
                <th style="padding: 8px; border: 1px solid #000;">Name</th>
                <th style="padding: 8px; border: 1px solid #000;">Hours</th>
                <th style="padding: 8px; border: 1px solid #000;">Cost</th>
            </tr>
        </thead>
        <tbody>`;

        Object.entries(groupedByPerson).forEach(([name, totalHours]) => {
            const roles = personRoleMap[name] || [];
            let hourlyRate = 0;

            Object.entries(filteredQuotation || {}).forEach(([_, typeServices]) => {
                Object.values(typeServices).forEach((items) => {
                    items.forEach((item) => {
                        if (item?.TypeService !== serviceName) return;

                        const match = item?.quotationDetails?.find((q) =>
                            roles.some((role) =>
                                q.designation?.toLowerCase().includes(role?.toLowerCase())
                            )
                        );
                        if (match) hourlyRate = match.hourlysalaray || 0;
                    });
                });
            });

            const totalCost = totalHours * hourlyRate;
            totalCostsArray.push(totalCost);
            totalCostsTyperService.push(totalCost);

            html += `<tr style="background-color: #e7ebfb;">
                <td style="padding: 4px; text-align: center; border: 1px solid #000;">${name}</td>
                <td style="padding: 4px; text-align: center; border: 1px solid #000;">${USAComma(totalHours)} Hrs</td>
                <td style="padding: 4px; text-align: center; border: 1px solid #000;">${hourlyRate > 0 ? `${currency}${USAComma(totalCost)}` : "(Hourly Rate Not Available)"}</td>
            </tr>`;
        });

        const total = totalCostsTyperService.reduce((sum, cost) => sum + cost, 0).toFixed(2);

        html += `<tr style="background-color: #bfdbfe; font-weight: bold;">
            <td colspan="2" style="padding: 4px; text-align: right; border: 1px solid #000;">Total:</td>
            <td style="padding: 4px; text-align: center; border: 1px solid #000;">${currency}${USAComma(total)}</td>
        </tr>
        </tbody>
    </table>`;

        if (serviceName === "Installation") {
            Object.entries(installation).forEach(([createdBy, tasks]) => {
                const tripDuration = tasks[0]?.tripduration || " ";
                html += `<div style="width: 100%; margin-top: 16px; border: 1px solid #000;">
                    <div style="background-color: #f3f4f6; font-size: 14px; font-weight: 500; padding: 8px; border-bottom: 1px solid #000;">TripDuration: ${tripDuration}</div>
                    <table style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr>
                                <th style="width: 10%; border: 1px solid #000; padding: 4px;">#</th>
                                <th style="width: 40%; border: 1px solid #000; padding: 8px;">Description</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Value</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Notes</th>
                            </tr>
                        </thead>
                        <tbody>`;

                tasks.forEach((row, index) => {
                    html += `<tr style="background-color: ${index % 2 === 0 ? '#fff' : '#f9fafb'};">
                            <td style="border: 1px solid #000; padding: 4px; text-align: center;">${index + 1}</td>
                            <td style="border: 1px solid #000; padding: 8px;">${row.description}</td>
                            <td style="border: 1px solid #000; padding: 8px;">${row.value}</td>
                            <td style="border: 1px solid #000; padding: 8px;">${row.notes}</td>
                        </tr>`;
                });

                html += `</tbody></table></div>`;
            });

            html += SalesFinanceEffortstableHtml || '';
            html += installationPLTableHtml || '';
        }

        if (serviceName === "Software") {
            Object.entries(installation).forEach(([createdBy, tasks], groupIndex) => {
                html += `<div style="width: 100%; margin-top: 16px; border: 1px solid #000;">
                    <div style="font-weight: bold; margin: 8px 0; padding: 8px; background-color: #f3f4f6;">Person :- ${groupIndex + 1}</div>
                    <table style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr>
                                <th style="width: 10%; border: 1px solid #000; padding: 4px;">#</th>
                                <th style="width: 40%; border: 1px solid #000; padding: 8px;">Description</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Value</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Notes</th>
                            </tr>
                        </thead>
                        <tbody>`;

                tasks.forEach((row, index) => {
                    html += `<tr style="background-color: ${index % 2 === 0 ? '#fff' : '#f9fafb'};">
                            <td style="border: 1px solid #000; padding: 4px; text-align: center;">${index + 1}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.description}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.value}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.notes}</td>
                        </tr>`;
                });

                html += `</tbody></table></div>`;
            });
        }

        if (serviceName === "Cloud") {
            Object.entries(installation).forEach(([createdBy, tasks], groupIndex) => {
                html += `<div style="width: 100%; margin-top: 16px; border: 1px solid #000;">
                    <div style="font-weight: bold; margin: 8px 0; padding: 8px; background-color: #f3f4f6;">Person :- ${groupIndex + 1}</div>
                    <table style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr>
                                <th style="width: 10%; border: 1px solid #000; padding: 4px;">#</th>
                                <th style="width: 40%; border: 1px solid #000; padding: 8px;">Description</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Value</th>
                                <th style="width: 25%; border: 1px solid #000; padding: 8px;">Notes</th>
                            </tr>
                        </thead>
                        <tbody>`;

                tasks.forEach((row, index) => {
                    html += `<tr style="background-color: ${index % 2 === 0 ? '#fff' : '#f9fafb'};">
                            <td style="border: 1px solid #000; padding: 4px; text-align: center;">${index + 1}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.description}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.value}</td>
                            <td style="border: 1px solid #000; padding: 8px; text-align: center;">${row.notes}</td>
                        </tr>`;
                });

                html += `</tbody></table></div>`;
            });
        }

        html += `</div>`;
        return html;
    };
    const htmlString =
        renderServiceTableHTML("Installation") +
        renderServiceTableHTML("Software") +
        renderServiceTableHTML("Cloud") +
        renderServiceTableHTML("Hardware");
    // useEffect(() => {
    //     if (sethtml) {
    //         sethtml(htmlString)
    //     }
    // }, [htmlString, sethtml]);


    const renderServiceTable = (serviceName) => {
        const groupedByPerson = {};
        const personRoleMap = {};
        const totalCostsTyperService = [];

        Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
            Object.entries(typeServices || {}).forEach(([typeService, items]) => {
                items.forEach((item) => {
                    if (item.TypeService !== serviceName || !item.WorkEntries?.length) return;

                    item.WorkEntries.forEach((entry) => {
                        const personName = entry?.createdBy?.name;
                        const personRoles = entry?.createdBy?.role || [];

                        if (!groupedByPerson[personName]) groupedByPerson[personName] = 0;
                        groupedByPerson[personName] += entry.hoursassigned || 0;

                        if (!personRoleMap[personName]) {
                            personRoleMap[personName] = personRoles;
                        }
                    });
                });
            });
        });

        if (Object.keys(groupedByPerson).length === 0) return null;

        return (
            <div className="border border-white my-4">
                <div className="w-full bg-[#e7ebfb] text-center font-semibold p-2">
                    {serviceName}
                </div>

                {Object.entries(groupedByPerson).map(([name, totalHours], i) => {
                    const roles = personRoleMap[name] || [];
                    let hourlyRate = 0;
                    Object.entries(filteredQuotation || {}).forEach(([_, typeServices]) => {
                        Object.values(typeServices).forEach((items) => {
                            items.forEach((item) => {
                                if (item?.TypeService !== serviceName) return;

                                const match = item?.quotationDetails?.find((q) =>
                                    roles.some((role) =>
                                        q.designation?.toLowerCase().includes(role?.toLowerCase())
                                    )
                                );
                                if (match) hourlyRate = match.hourlysalaray || 0;
                            });
                        });
                    });

                    const totalCost = totalHours * hourlyRate;
                    totalCostsArray.push(totalCost);
                    totalCostsTyperService.push(totalCost);
                    // settotal(totalCost)

                    return (
                        <div key={`${name}-${i}`} className="flex w-full bg-[#e7ebfb] border border-white divide-x divide-white text-center text-sm">
                            <div className="flex p-1">{name}</div>
                            <div className="flex p-1">{USAComma(totalHours)} Hrs</div>
                            <div className="flex p-1">
                                {hourlyRate > 0 ? `${currency}${USAComma(totalCost)}` : "(Hourly Rate Not Available)"}
                            </div>
                        </div>
                    );
                })}

                <div className="flex w-full bg-[#e7ebfb] border border-white text-end text-sm">
                    <div className="flex p-1"></div>
                    <div className="flex p-1"></div>
                    <div className=" p-1 font-semibold flex gap-2">
                        <p className="text-se">Total:- </p>
                        {currency}{USAComma(totalCostsTyperService.reduce((sum, cost) => sum + cost, 0).toFixed(2))}
                    </div>
                </div>

                {serviceName === "Installation" && (
                    <>
                        {Object.entries(installation).map(([createdBy, tasks], groupIndex) => (
                            <div key={createdBy} className="w-full">
                                {/* Optional: Show createdBy title */}
                                <div className="bg-gray-100 text-sm font-medium p-2">
                                    TripDuration: {tasks[0].tripduration || " "}
                                </div>

                                {tasks.map((row, index) => (
                                    <div
                                        key={row._id}
                                        className="flex items-center text-center w-full text-xs"
                                    >
                                        <div className="w-full">
                                            <div className="head flex">
                                                <div className="w-[10%] border p-1">{index + 1}</div>

                                                <div className="w-[40%] border p-2">{row.description}</div>

                                                <div className="w-[25%] border p-2">{row.value}</div>

                                                <div className="w-[25%] border p-2">{row.notes}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                        {installationPLTableHtml}
                        {SalesFinanceEffortstableHtml}
                    </>
                )}
                {serviceName === "Software" && (
                    <>
                        {Object.entries(installation).map(([createdBy, tasks], groupIndex) => (
                            <div key={createdBy} className="w-full">
                                <div className="font-bold my-2">
                                    Person :- {groupIndex + 1}
                                </div>

                                {tasks.map((row, index) => (
                                    <div
                                        key={row._id}
                                        className="flex items-center text-center w-full text-xs"
                                    >
                                        <div className="w-full">
                                            <div className="head flex">
                                                <div className="w-[10%] border p-1">{index + 1}</div>

                                                <div className="w-[40%] border p-2">{row.description}</div>

                                                <div className="w-[25%] border p-2">{row.value}</div>

                                                <div className="w-[25%] border p-2">{row.notes}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}

                    </>
                )}

                {serviceName === "Cloud" && (
                    <>
                        {Object.entries(installation).map(([createdBy, tasks], groupIndex) => (
                            <div key={createdBy} className="w-full">
                                <div className="font-bold my-2">
                                    Person :- {groupIndex + 1}
                                </div>

                                {tasks.map((row, index) => (
                                    <div
                                        key={row._id}
                                        className="flex items-center text-center w-full text-xs"
                                    >
                                        <div className="w-full">
                                            <div className="head flex">
                                                <div className="w-[10%] border p-1">{index + 1}</div>

                                                <div className="w-[40%] border p-2">{row.description}</div>

                                                <div className="w-[25%] border p-2">{row.value}</div>

                                                <div className="w-[25%] border p-2">{row.notes}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}

                    </>
                )}

            </div>
        );
    };

    const hasTypeService = (serviceType) => {
        return Object.values(filteredQuotation || {}).some((typeServices) =>
            Object.keys(typeServices).includes(serviceType)
        );
    };

    const onGeneratedHtml = (html) => {
        setInstallationPLTableHtml(html);
    };

    const onHtmlGenerated = (html) => {
        setSalesFinanceEffortstableHtml(html);
    };




    useEffect(() => {
        if (sethtml) {
            sethtml(htmlString);
        }
    }, [htmlString, sethtml]);


    return (
        <div className="bg-white rounded-md py-3 mt-3 p-2">
            {/* <div className="flex justify-between bg-white text-lg font-semibold">
                <div>
                    <h2>Salesperson Finance - Employee Efforts Calculation</h2>
                </div>
            </div> */}
            <>
                <div style={{ display: 'none' }}>
                    {showInstallationData && (
                        <>
                            <div className="Employee_Efforts_Calculation" >
                                {hasTypeService("Installation") && (
                                    <>
                                        {renderServiceTable("Installation")}

                                    </>
                                )}

                                {hasTypeService("Software") && (
                                    <>
                                        {renderServiceTable("Software")}
                                    </>
                                )}

                                {hasTypeService("Cloud") && (
                                    renderServiceTable("Cloud")
                                )}

                                {hasTypeService("Hardware") && (
                                    renderServiceTable("Hardware")

                                )}
                            </div>
                        </>
                    )}

                </div>

                {filteredQuotation &&
                    Object.values(filteredQuotation).some(
                        (services) => services.Installation
                    ) && (
                        <div style={{ display: 'none' }}>
                            <SalesEfforts
                                filteredQuotation={filteredQuotation}
                                projectServiceCostMap={projectServiceCostMap}
                                onHtmlGenerated={onHtmlGenerated}

                            />
                            <SalesIntallation
                                filteredQuotation={filteredQuotation}
                                projectServiceCostMap={projectServiceCostMap}
                                onGeneratedHtml={onGeneratedHtml}
                                total={serviceTotals.Installation || 0}
                            />
                        </div>
                    )}

            </>
        </div>
    )
}

export default SalesCalculations